import { render, staticRenderFns } from "./CreateGalleryModal.vue?vue&type=template&id=1da72d27&scoped=true&"
import script from "./CreateGalleryModal.vue?vue&type=script&lang=js&"
export * from "./CreateGalleryModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateGalleryModal.vue?vue&type=style&index=0&id=1da72d27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da72d27",
  null
  
)

export default component.exports